<label class="bmd-label-floating"><b>{{label}}</b></label>
<mat-form-field>
    <mat-select [formControl]="control" multiple>
        <mat-option [value]="'All'" (click)="toggleSelectAll()">All</mat-option>
        <mat-option *ngFor="let item of items" [value]="item.id" (click)="onSelectionChange()">{{item.name}} {{item.surname}}</mat-option>
    </mat-select>
</mat-form-field>
